import { useContext, type FC } from 'react';
import './vol-surface-timeseries-styles.scss';
import InlineOptions from '../../inline-options';

import { RangeOptions } from '../../constants/volatility-options';
import { RangeEnum } from '../../../../model/range.enum';
import AddRealizedSeries from './add-surface-series';
import VolSurfaceTimeseriesChart from './vol-surface-timeseries-chart';
import { RequestTypeEnum, TimeseriesContext } from '../../../../providers/timeseries-provider';

const VolSurfaceTimeseriesContent: FC<{ onlyPerps?: boolean }> = ({ onlyPerps }) => {
  const { range, setRange, addSeries, seriesExists } = useContext(TimeseriesContext);

  const handleApply = (options: Record<string, any>) => {
    if (options.type === RequestTypeEnum.PERPETUAL) {
      addSeries(options?.token, '', '', RequestTypeEnum.PERPETUAL);
    }

    if (options.type === RequestTypeEnum.VOLS) {
      addSeries(options?.token, options?.tenor, options?.delta, RequestTypeEnum.VOLS);
    }
  };

  const renderInlineOptions = () => (
    <div className="vol-surface-timeseries-header">
      <InlineOptions
        options={RangeOptions}
        selectedOption={range}
        onOptionChange={(val) => {
          if (Array.isArray(val) && val.length) {
            setRange(val[0] as RangeEnum);
            return;
          }

          setRange(val as RangeEnum);
        }}
        maxVisibleOptions={10}
      />
      <AddRealizedSeries onApply={handleApply} seriesExists={seriesExists} onlyPerps={onlyPerps} />
    </div>
  );

  return (
    <div className="vol-surface-timeseries-content">
      {renderInlineOptions()}
      <VolSurfaceTimeseriesChart />
    </div>
  );
};

export default VolSurfaceTimeseriesContent;
